export default "__VITE_ASSET__xX3ZA0tw__"